import React, { useState, useEffect } from "react";
import { Add } from "@mui/icons-material";
import {
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { MultiSelect } from "../../table/Filter";

import {
  getActivePaymentMethods,
  paymentBrandAction,
} from "../../../services/payment";
import { Log } from "../../../services/services";
import * as Yup from "yup";
import { useFormik } from "formik";
import { styles } from "../../../utils/styles";
import FormDialog from "../../FormDialog";
import { GREY } from "../../../theme/palette";

function CreateBrandDialog() {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getActivePaymentMethods(setPaymentMethods, setLoaded);
  }, []);

  //Dialog Stuff
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    Log.info('Click button [New Payment Brand] - show popup Add new payment brand');
    setOpen(true);
  };
  const handleClose = () => {
    resetForm();
    setOpen(false);
  };

  const {
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    values,
    touched,
    isSubmitting,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: "",
      payment_method: [],
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required("This field is required")
        .test('not-whitespace-only', 'This field is required', function(value) {
          return value && value.trim().length > 0;
        }),
      payment_method: Yup.array().min(1, "This field is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      const name = values.name.trim();
      Log.info('Click button [Add Payment Brand] - Add new payment brand', { ...values, name });
      await paymentBrandAction("ADD", { ...values, name });
      setSubmitting(false);
      handleClose();
      setLoaded(true);
      
    },
  });

  return (
    <div>
      <Button variant="contained" onClick={handleClickOpen} startIcon={<Add />} sx={{ ...styles.customButton }}>
        New Payment Brand
      </Button>
      <FormDialog
        open={open}
        onClose={handleClose}
        title="Add New Payment Brand"
        handleSubmit={handleSubmit}
        loading={isSubmitting}
        maxWidth="sm"
      >
        {loaded && (
          <>
            <Typography sx={{ pb: 0.5, color: GREY[600], fontSize: 12 }}>
              Payment Methods
            </Typography>
            <MultiSelect
            name="payment_method"
            options={paymentMethods.name.map((method) => ({
              value: method.id ? method.id : "",
              label: method.name ? method.name : "",
            }))}
            selectedValues={values.payment_method}
            setSelectedValues={data => setFieldValue("payment_method", data)}
            errorMsg={touched.payment_method && errors.payment_method}
            />
          </>
        )}
        <TextField
          name="name"
          label="Name of payment brand"
          fullWidth
          variant="standard"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(touched.name && errors.name)}
          helperText={touched.name && errors.name}
          disabled={isSubmitting}
          sx={{ my: 2 }}
        />
      </FormDialog>
    </div>
  );
}

export default CreateBrandDialog;
